( function ( $ ) {

	MP.sticky_header = function(){

		var header = document.getElementById('site-top');

		if ( !header ) return;
		
		lib.on( ['load','resize','scroll'] ,function(){

			header.style.top = lib.offset('#wpadminbar') + 'px';

			if (window.pageYOffset > 0 ){
				document.body.classList.add('is-sticky-header');
			} else {
				document.body.classList.remove('is-sticky-header');
			}
			
		});
	};

	function Mobile_Menu(args){
		this.holder = document.querySelector(args.holder);
		this.btn = document.querySelector(args.btn);
		this.menu = document.createElement('div');

		this.$mainMenu = $('#main_menu');
		this.$bottomAppendTop = $('#top_login_register');
		this.$servciePluginPurchase = $('#footer_services_plugin_purchase');
		
	}

	var MMp = Mobile_Menu.prototype;	

	MMp.structure = function(){

		this.menu.className = 'main-menu'; 

		document.body.appendChild ( this.menu );

		this.menu.innerHTML = `
			<div class="h100 l-column main-menu-holder">

				<div class="l-fg1-h0 menu-list-hold">

				</div>

				<div class="mobile_menu_bottom">

					<div class="mobile_menu_bottom-top">

					</div>

					<div class="mobile_menu_bottom-bottom">

					</div>

				</div>

			</div>
		`;

		var cloned = this.$mainMenu.clone().removeAttr('id')

		// dashboard sidebar
		cloned.find('.dashboard-sidebar-link').removeClass('dashboard-sidebar-link')
		if(cloned.find('nav')){
			//cloned.find('nav').andSelf().filter('nav').addClass('top-menu')
		}
		cloned.removeClass('dashboard-sidebar')

		$( this.menu.querySelector( '.menu-list-hold' ) ).append ( cloned );
		$( this.menu.querySelector( '.mobile_menu_bottom-top' ) ).append ( this.$bottomAppendTop.clone().removeAttr('id') );
		$( this.menu.querySelector( '.mobile_menu_bottom-bottom' ) ).append ( this.$servciePluginPurchase.clone().removeAttr('id') );
		
	};
	MMp._mobile_menu_top = function(){
		var offset_string = '#wpadminbar,#site-top',
			_self = this;
		lib.on( 'resize' , function(){
			_self.menu.style.top = lib.offset( offset_string ) - 1 + 'px';
			_self.menu.style.height = lib.viewport().height - lib.offset( offset_string ) + 1 + 'px';
		});
	};
	MMp.mobile_menu_sub = function(){
		
		if ( ! this.holder ) return;

		var lis = this.holder.querySelectorAll('li');
		
		if ( ! lis.length ) return;

		[].forEach.call( lis , function( li ){
			
			var ul = li.querySelector('ul');
			
			if(!ul) return;

			ul = $(ul);

			var open_sub = document.createElement('button'),
				aria_hidden = ( lib.viewport().width < tablet ) ? 'true' : 'false';

			open_sub.className = 'open_sub';
			open_sub.setAttribute('aria-hidden',aria_hidden);

			var a = li.querySelector('a');

			a.appendChild( open_sub );

			open_sub.addEventListener('click',function(e){
				e.preventDefault();  
				$(this).toggleClass('is-on');
				var slideDir = ul.css('display') == 'none' ? 'Down' : 'Up';
				ul['slide' + slideDir](200);
			});

		});

	};
	MMp.mobile_meu_open = function(){
		if ( ! this.btn ) return;
		var _self = this;
		
		$( this.btn ).menuBtn();


		this.btn.addEventListener('click',function(){
			
			$(this).toggleClass('is-active');
			$('body').toggleClass('is-main-menu-active');
			_self._mobile_menu_top();

		});
	};
	MMp.mega_menu = function(){
		$('.mega-menu-item').parent().addClass('mega-menu');
		$('.mega-menu-item').wrapAll('<li class="js-mega_menu"><ul class="norm-ul l-flex mega-menu-table"></ul></li>');
	};


	var main_menu = new Mobile_Menu({
		holder : "#main_menu",
		btn : "#nenu_btn",
		fold : tablet,
		name : 'main-menu',
		additional_html_btns : '.btn-top--login , .mobile-menu-link'
	});

	lib.run_all( main_menu );

	MP.toggle_search_display = function(){
		$('#show_mobile_search').on('click',function(){
			var $search = $(this).parent().find('.search_site');
			$search.toggleClass('is-shown');
		});
	};

	MP.a11y_btn = function(){

		$('.header-internal + .t-part').prepend( '<div id="has-mobile-a11y-btn"></div>' );
		$('#a11y-menu-btn').on('click',function(){

			var real = document.querySelector(' .iAccessibility-menu-button '),
				panel =$('#iAccessibility-menu,.iAccessibility-menu-button');
			if ( ! real ) return;

			real.click();
			panel.css({top : lib.offset('#wpadminbar , #site-top')});

			if ( document.getElementById('close_acc')) return;

			var close = document.createElement('button');
			close.id = "close_acc";
			close.textContent = "X";
			var accMenu = document.getElementById('iAccessibility-menu');
			accMenu.appendChild(close);
			close.addEventListener('click',function(){
				real.click();
			});

		});	

		var a11yBtnHolder = document.getElementById('has-mobile-a11y-btn'),
			offsetStringA11yPos = '#wpadminbar, #site-top' ;
		
		function a11yBtnPos(){

			if ( ! a11yBtnHolder ) return;
			
			var ref = a11yBtnHolder.getBoundingClientRect().top,
				top = lib.offset( offsetStringA11yPos );

			if ( ! a11yBtnHolder.firstElementChild ) return;

			if ( ref < top ){
				a11yBtnHolder.firstElementChild.classList.add('is-fixed-btn');
				a11yBtnHolder.firstElementChild.style.top = top + 'px';
			} else {
				a11yBtnHolder.firstElementChild.classList.remove('is-fixed-btn');
				a11yBtnHolder.firstElementChild.style.top = '';
			}

		}

		a11yBtnPos();
		window.addEventListener('scroll', a11yBtnPos);
		window.addEventListener('load', a11yBtnPos);

	};


}) ( window.jQuery);


// WEBPACK FOOTER //
// ./assets/js/l-header.js